import React, { useState } from 'react';
import './EPaperCalendar.css';

const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

export default function EPaperCalendar({ availableDates = [], onDateSelect }) {
  const today = new Date();
  const [current, setCurrent] = useState({ year: today.getFullYear(), month: today.getMonth() });

  const daysInMonth = new Date(current.year, current.month + 1, 0).getDate();
  const firstDay = new Date(current.year, current.month, 1).getDay();

  const prevMonth = () => {
    setCurrent(c => c.month === 0
      ? { year: c.year - 1, month: 11 }
      : { year: c.year, month: c.month - 1 });
  };
  const nextMonth = () => {
    setCurrent(c => c.month === 11
      ? { year: c.year + 1, month: 0 }
      : { year: c.year, month: c.month + 1 });
  };

  const dateKey = (day) => {
    const m = String(current.month + 1).padStart(2,'0');
    const d = String(day).padStart(2,'0');
    return `${current.year}-${m}-${d}`;
  };

  const todayKey = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`;

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div className="epaper-calendar">
      <div className="cal-header">
        <button className="cal-nav" onClick={prevMonth}>◀</button>
        <h3 className="cal-month-title">{MONTHS[current.month]} {current.year}</h3>
        <button className="cal-nav" onClick={nextMonth}>▶</button>
      </div>
      <div className="cal-days-header">
        {DAYS.map(d => <span key={d}>{d}</span>)}
      </div>
      <div className="cal-grid">
        {cells.map((day, i) => {
          if (!day) return <div key={`empty-${i}`} className="cal-cell empty" />;
          const key = dateKey(day);
          const isAvailable = availableDates.includes(key);
          const isToday = key === todayKey;
          return (
            <button
              key={key}
              className={`cal-cell ${isAvailable ? 'available' : 'unavailable'} ${isToday ? 'today' : ''}`}
              onClick={() => onDateSelect(key, isAvailable)}
            >
              {day}
              {isAvailable && <span className="cal-dot" />}
            </button>
          );
        })}
      </div>
      <div className="cal-legend">
        <span><span className="legend-dot available" />Available</span>
        <span><span className="legend-dot unavailable" />Unavailable</span>
        <span><span className="legend-dot today" />Today</span>
      </div>
    </div>
  );
}
